var render, staticRenderFns
import script from "./StatusIndicator.vue?vue&type=script&lang=ts&"
export * from "./StatusIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./StatusIndicator.vue?vue&type=style&index=0&id=58baf0aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports